import React, { ReactElement } from 'react'
import styled from 'styled-components'
import { LoaderIcon, LoaderIconProps } from '../../icons/LoaderIcon'

const Wrapper = styled.div<LoaderIconProps>`
  svg {
    height: 48px;
    width: 48px;
    background-size: 48px;
    animation: loader 1s linear infinite;
  }
  @keyframes loader {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`
const Loader = ({ color }: LoaderIconProps): ReactElement => {
  return (
    <Wrapper>
      <LoaderIcon color={color} />
    </Wrapper>
  )
}

export { Loader }
